import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Ecommerce',
      component: () => import('../views/Ecommerce.vue'),
      meta: {
        title: 'eCommerce Dashboard',
      },
    },
    {
      path: '/market/ongoing',
      name: 'Ongoing sales',
      component: () => import('../views/SalesOngoing.vue'),
      meta: {
        title: 'Ongoing sales Dashboard',
      },
    },
    {
      path: '/market/draft',
      name: 'Draft sales',
      component: () => import('../views/SalesDraft.vue'),
      meta: {
        title: 'Draft sales Dashboard',
      },
    },
    {
      path: '/supply',
      name: 'Supply',
      component: () => import('../views/Supply.vue'),
      meta: {
        title: 'Cards Supply',
      },
    },
    {
      path: '/credits/user-transactions',
      name: 'User Credits transactions',
      component: () => import('../views/UserCreditsTx.vue'),
      meta: {
        title: 'User Credit Transactions',
      },
    },
    {
      path: '/credits/sent-to-users',
      name: 'Credits Sent',
      component: () => import('../views/CreditsSent.vue'),
      meta: {
        title: 'Credits Sent',
      },
    },
    {
      path: '/users',
      name: 'Users',
      component: () => import('../views/UserDirectory.vue'),
      meta: {
        title: 'Users Dashboard',
      },
    },
    {
      path: '/gameweeks',
      name: 'Gameweeks',
      component: () => import('../views/Gameweeks.vue'),
      meta: {
        title: 'Gameweeks Dashboard',
      },
    },
    {
      path: '/users/:username',
      name: 'Users Profile',
      component: () => import('../views/UserProfile.vue'),
      meta: {
        title: 'User Profile',
      },
    },
    {
      path: '/gameweeks',
      name: 'Gameweeks',
      component: () => import('../views/Gameweeks.vue'),
      meta: {
        title: 'User Profile',
      },
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: () => import('../views/Others/Calendar.vue'),
      meta: {
        title: 'Calendar',
      },
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('../views/Others/UserProfile.vue'),
      meta: {
        title: 'Profile',
      },
    },
    {
      path: '/form-elements',
      name: 'Form Elements',
      component: () => import('../views/Forms/FormElements.vue'),
      meta: {
        title: 'Form Elements',
      },
    },
    {
      path: '/basic-tables',
      name: 'Basic Tables',
      component: () => import('../views/Tables/BasicTables.vue'),
      meta: {
        title: 'Basic Tables',
      },
    },
    {
      path: '/line-chart',
      name: 'Line Chart',
      component: () => import('../views/Chart/LineChart/LineChart.vue'),
    },
    {
      path: '/bar-chart',
      name: 'Bar Chart',
      component: () => import('../views/Chart/BarChart/BarChart.vue'),
    },
    {
      path: '/alerts',
      name: 'Alerts',
      component: () => import('../views/UiElements/Alerts.vue'),
      meta: {
        title: 'Alerts',
      },
    },
    {
      path: '/avatars',
      name: 'Avatars',
      component: () => import('../views/UiElements/Avatars.vue'),
      meta: {
        title: 'Avatars',
      },
    },
    {
      path: '/badge',
      name: 'Badge',
      component: () => import('../views/UiElements/Badges.vue'),
      meta: {
        title: 'Badge',
      },
    },

    {
      path: '/buttons',
      name: 'Buttons',
      component: () => import('../views/UiElements/Buttons.vue'),
      meta: {
        title: 'Buttons',
      },
    },

    {
      path: '/images',
      name: 'Images',
      component: () => import('../views/UiElements/Images.vue'),
      meta: {
        title: 'Images',
      },
    },
    {
      path: '/videos',
      name: 'Videos',
      component: () => import('../views/UiElements/Videos.vue'),
      meta: {
        title: 'Videos',
      },
    },
    {
      path: '/blank',
      name: 'Blank',
      component: () => import('../views/Pages/BlankPage.vue'),
      meta: {
        title: 'Blank',
      },
    },

    {
      path: '/error-404',
      name: '404 Error',
      component: () => import('../views/Errors/FourZeroFour.vue'),
      meta: {
        title: '404 Error',
      },
    },

    {
      path: '/signin',
      name: 'Signin',
      component: () => import('../views/Auth/Signin.vue'),
      meta: {
        title: 'Signin',
      },
    },
    {
      path: '/automate',
      name: 'Automate',
      component: () => import('../views/Automate.vue'),
      meta: {
        title: 'Automate',
      },
    },
    {
      path: '/signup',
      name: 'Signup',
      component: () => import('../views/Auth/Signup.vue'),
      meta: {
        title: 'Signup',
      },
    },
  ],
})

export default router

router.beforeEach((to, from, next) => {
  const publicPages = ['/signin', '/signup']
  const authRequired = to.meta.requiresAuth !== false && !publicPages.includes(to.path)
  const token = localStorage.getItem('token')

  if (authRequired && !token) {
    return next('/signin')
  }
  document.title = `Fungiball Admin - ${to.meta.title || 'Dashboard'}`
  next()
})
